import PropTypes from "prop-types"
import React from "react"
import Navigation from "./Navigation"
import Image from './Image'

const Header = ({ siteTitle }) => (
    <header className="fade-1">
        <nav className="navbar navbar-default navbar-fixed-top">
            <div className="container">
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                        <span className="sr-only">Toggle navigation</span>
                                            <span className="alt-menu">menu</span>
                    </button>
                    <a className="navbar-brand" href="/">
                        <Image imgsrc="instant-checkmate-logo-400px.png" style={{ width: '220px', margin: '0 auto' }}alt="Instant Checkmate Logo" />
                    </a>
                </div>
                <div id="navbar" className="navbar-collapse collapse">
                    <Navigation></Navigation>
                </div>
            </div>
            <div className="icm-search">
                <div className="container">
                    <form className="icm_search form-inline" method="get" target="_top" action="https://www.instantcheckmate.com/search/?">

                        <div className="form-wrapper">
                            <div className="form-group fname">
                                <input required id="fname" className="form-control" type="text" name="fname" placeholder="First" tabIndex="1" pattern="[a-zA-Z- ]+"/>
                            </div>
                            <div className="form-group mname">
                                <input className="form-control-small" type="text" maxLength="1" name="middleInitial" placeholder="M" tabIndex="2" pattern="[a-zA-Z- ]+"/>
                            </div>
                            <div className="form-group lname">
                                <input required id="lname" className="form-control" type="text" name="lname" placeholder="Last" tabIndex="3" pattern="[a-zA-Z- ]+"/>
                            </div>
                            <div className="form-group age">
                                <input className="form-control-small" type="text" name="age" maxLength="3" placeholder="Age" tabIndex="4" pattern="[0-9]+"/>
                            </div>
                            <div className="form-group city">
                                <input id="city" className="form-control" type="text" name="city" placeholder="City" tabIndex="5" pattern="[a-zA-Z- ]+"/>
                            </div>
                            <div className="form-group state">
                                <select id="state" className="form-control" name="state" tabIndex="6">
                                    <option value='ALL'>All States</option>
                                    <option value='AL'>Alabama</option>
                                    <option value='AK'>Alaska</option>
                                    <option value='AZ'>Arizona</option>
                                    <option value='AR'>Arkansas</option>
                                    <option value='CA'>California</option>
                                    <option value='CO'>Colorado</option>
                                    <option value='CT'>Connecticut</option>
                                    <option value='DE'>Delaware</option>
                                    <option value='FL'>Florida</option>
                                    <option value='GA'>Georgia</option>
                                    <option value='HI'>Hawaii</option>
                                    <option value='ID'>Idaho</option>
                                    <option value='IL'>Illinois</option>
                                    <option value='IN'>Indiana</option>
                                    <option value='IA'>Iowa</option>
                                    <option value='KS'>Kansas</option>
                                    <option value='KY'>Kentucky</option>
                                    <option value='LA'>Louisiana</option>
                                    <option value='ME'>Maine</option>
                                    <option value='MD'>Maryland</option>
                                    <option value='MA'>Massachusetts</option>
                                    <option value='MI'>Michigan</option>
                                    <option value='MN'>Minnesota</option>
                                    <option value='MS'>Mississippi</option>
                                    <option value='MO'>Missouri</option>
                                    <option value='MT'>Montana</option>
                                    <option value='NE'>Nebraska</option>
                                    <option value='NH'>New Hampshire</option>
                                    <option value='NJ'>New Jersey</option>
                                    <option value='NM'>New Mexico</option>
                                    <option value='NY'>New York</option>
                                    <option value='NC'>North Carolina</option>
                                    <option value='ND'>North Dakota</option>
                                    <option value='OH'>Ohio</option>
                                    <option value='OK'>Oklahoma</option>
                                    <option value='OR'>Oregon</option>
                                    <option value='PA'>Pennsylvania</option>
                                    <option value='RI'>Rhode Island</option>
                                    <option value='SC'>South Carolina</option>
                                    <option value='SD'>South Dakota</option>
                                    <option value='TN'>Tennessee</option>
                                    <option value='TX'>Texas</option>
                                    <option value='UT'>Utah</option>
                                    <option value='VT'>Vermont</option>
                                    <option value='VA'>Virginia</option>
                                    <option value='WA'>Washington</option>
                                    <option value='DC'>Washington D.C.</option>
                                    <option value='WV'>West Virginia</option>
                                    <option value='WI'>Wisconsin</option>
                                    <option value='WY'>Wyoming</option>
                                </select>
                            </div>
                        </div>

                        <button type="submit" className="btn submit-button" tabIndex="4" id="hero-search">Search 
                        </button>
                    </form>
                </div>
            </div>
        </nav>
    </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
